import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Button } from './ui/button';
import { scrollToSection } from '../lib/scroll';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();
  const headerOpacity = useTransform(scrollY, [0, 100], [0.95, 1]);
  const headerBlur = useTransform(scrollY, [0, 100], [0, 12]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToConsultation = () => {
    scrollToSection('consultation', -100);
  };

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'py-3' : 'py-6'
      }`}
      style={{
        opacity: headerOpacity,
        backdropFilter: `blur(${headerBlur}px)`,
        backgroundColor: isScrolled ? 'rgba(26, 35, 50, 0.85)' : 'transparent',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex items-center"
        >
          <div className="inline-flex items-center justify-center bg-white rounded-xl border border-[#c9a961]/50 shadow-lg shadow-black/20 p-2 md:p-2.5 transition-all duration-500 hover:border-[#c9a961] hover:shadow-[#c9a961]/20">
            <img
              src="/logo.webp"
              alt="Johann C Strauss"
              className={`transition-all duration-500 w-auto ${isScrolled ? 'h-14' : 'h-20'}`}
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <Button
            onClick={scrollToConsultation}
            data-testid="header-consultation-btn"
            className="bg-[#c9a961] hover:bg-[#b89851] text-[#1a2332] font-semibold px-6 md:px-8 py-5 md:py-6 text-sm md:text-base rounded-none transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#c9a961]/20"
          >
            Request Private Consultation
          </Button>
        </motion.div>
      </div>
    </motion.header>
  );
};

export default Header;
